import React, { useState } from "react";
import IndicatorChart from "./IndicatorChart";
import { IndicatorBlock } from "./IndicateurTableContainer";

interface Props {
  indicatorData: Record<number, IndicatorBlock>;
  chartType?: "bar" | "line" | "area" | "pie"; // type par défaut pour tous
}

const IndicateurChartContainer: React.FC<Props> = ({ indicatorData, chartType = "bar" }) => {
  const indicatorIds = Object.keys(indicatorData);

  const [activeIndex, setActiveIndex] = useState(0);

  if (indicatorIds.length === 0) return <p>Aucun indicateur à afficher.</p>;

  const currentId = Number(indicatorIds[activeIndex]);
  const bloc = indicatorData[currentId];

  return (
    <div style={{ width:"100%",flexDirection: "column", gap: 20, alignItems: "center" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
        <button
          className="btn btn-sm btn-secondary"
          disabled={activeIndex === 0}
          onClick={() =>
            setActiveIndex((prev) => (prev - 1 + indicatorIds.length) % indicatorIds.length)
          }
        >
          ◀
        </button>

        <div style={{width:"100%"}}>
          <h5 style={{ textAlign: "center" }}>{bloc.meta.nom}</h5>
          <IndicatorChart rows={bloc.rows} chartType={chartType} indicatorName={bloc.meta.nom} />
        </div>

        <button
          className="btn btn-sm btn-secondary"
          disabled={activeIndex === indicatorIds.length-1}
          onClick={() =>
            setActiveIndex((prev) => (prev + 1) % indicatorIds.length)
          }
        >
          ▶
        </button>
      </div>

      <p style={{ textAlign:"center" ,fontSize: 12, color: "#666" }}>
        {activeIndex + 1} / {indicatorIds.length}
      </p>
    </div>
  );
};

export default IndicateurChartContainer;